<template>
  <BaseModal
    ref="modal"
    modal-classes="max-w-md mx-auto mt-16"
    @modal-after-leave="$emit('closed')"
  >
    <template #header>
      <h3 class="text-2xl text-gray-900">Edit contact list</h3>
    </template>

    <template #default="modalProps">
      <ContactListForm
        :submit-action="submitAction"
        :default-data="contactList"
        @cancel="modalProps.close"
      />
    </template>
  </BaseModal>
</template>

<script>
import { mapActions } from 'vuex';
import ContactListForm from '@/components/ContactLists/Form.vue';

export default {
  components: {
    ContactListForm,
  },

  props: {
    contactList: { type: Object, required: true },
  },

  methods: {
    ...mapActions('ui/contactLists', {
      updateContactList: 'update',
    }),
    submitAction(formData) {
      const { id: contactListUuid } = this.contactList;

      return this.updateContactList({ contactListUuid, formData })
        .then((response) => Promise.resolve(response))
        .catch((error) => Promise.reject(error));
    },
  },
};
</script>
